import { createWebHistory, createRouter } from "vue-router";
import ClientLayout from "@/layouts/ClientLayout.vue";
import AdminLayout from "@/layouts/AdminLayout.vue";
import { canActivate } from '@/services/auth-guard.service';

const routes = [
    {
        path: "/",
        component: ClientLayout,
        children: [
            { path: "", meta: { label: "Agenda" }, component: () => import("@/views/client/HelloWorld.vue") },
            { path: "privacy", meta: { label: "Privacy" }, component: () => import("@/views/client/Privacy.vue") },
            { path: "terms", meta: { label: "Terms" }, component: () => import("@/views/client/Terms.vue") }
        ]
    },
    {
        path: "/admin",
        component: AdminLayout,
        children: [
            { path: "", meta: { label: "Admin" }, component: () => import("@/views/admin/Main.vue") },
            { path: "init", meta: { label: "Init" }, component: () => import("@/views/admin/Init.vue") },
            {
                path: "agendas",
                children: [
                    { path: "", meta: { label: "Agendas" }, component: () => import("@/views/admin/agenda/Index.vue") },
                    { path: "new", meta: { label: "New Agenda" }, component: () => import("@/views/admin/agenda/New.vue") },
                    { 
                        path: ":id",
                        children: [
                            { path: "", meta: { label: "Edit Agenda" }, component: () => import("@/views/admin/agenda/Edit.vue") },
                            { path: "attendance", component: () => import("@/views/admin/agenda/attendance/Index.vue") }
                        ]
                    },
                ]
            },
            {
                path: "contacts",
                component: "",
                children: [
                    { path: "", meta: { label: "Contacts" }, component: () => import("@/views/admin/contact/Index.vue") },
                    { path: "new", meta: { label: "New Contact" }, component: () => import("@/views/admin/contact/New.vue") },
                    { path: ":id", meta: { label: "Edit Contact" }, component: () => import("@/views/admin/contact/Edit.vue") },
                    { path: "inactivity-policy", meta: { label: "Contact Inactivity Policy" }, component: () => import("@/views/admin/contact/InactivityPolicy.vue") }
                ]
            },
            {
                path: "categories",
                component: "",
                children: [
                    { path: "", meta: { label: "Categories" }, component: () => import("@/views/admin/category/Index.vue") },
                    { path: "new", meta: { label: "New Category" }, component: () => import("@/views/admin/category/New.vue") },
                    { path: ":id", meta: { label: "Edit Category" }, component: () => import("@/views/admin/category/Edit.vue") }
                ]
            },
            {
                path: "locations",
                component: "",
                children: [
                    { path: "", meta: { label: "Locations" }, component: () => import("@/views/admin/location/Index.vue") },
                    { path: "new", meta: { label: "New Location" }, component: () => import("@/views/admin/location/New.vue") },
                    { path: ":id", meta: { label: "Edit Location" }, component: () => import("@/views/admin/location/Edit.vue") }
                ]
            },
            {
                path: "groups",
                component: "",
                children: [
                    { path: "", meta: { label: "Groups" }, component: () => import("@/views/admin/group/Index.vue") },
                    { path: "new", meta: { label: "New Group" }, component: () => import("@/views/admin/group/New.vue") },
                    { 
                        path: ":id", 
                        children: [
                             { path: "", meta: { label: "Edit Group" }, component: () => import("@/views/admin/group/Edit.vue") },
                             { path: "members", component: () => import("@/views/admin/group/members/Index.vue") }
                        ]
                    }
                ]
            }
        ],
        beforeEnter: (to, from, next) => {
            next(canActivate())
        },
    },
    {
        path: "/callback",
        name: "Callback",
        component: () => import('@/views/Callback.vue'),
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        // Browser back/forward buttons
        if (savedPosition) {
            return savedPosition
        }

        // Scroll to top on route change
        return { top: 0 }
    }
});

router.afterEach((to) => {
  const nearestWithLabel = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta?.label);

  document.title = nearestWithLabel
    ? `${nearestWithLabel.meta.label}`
    : 'Agenda';
});

export default router;